import { cva, type VariantProps } from 'class-variance-authority';

export const formFieldSizeVariants = cva('', {
  variants: {
    size: {
      sm: 'min-w-[160px]',
      md: 'min-w-[240px]',
      lg: 'min-w-[320px]',
      // fullの場合は何も指定しない。つまり100%の幅になる。
      full: 'w-full',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

export type FormFieldSize = NonNullable<VariantProps<typeof formFieldSizeVariants>['size']>;
